import { Link } from "react-router-dom";

const columnData = [
  {
    header: "  شماره قرارداد",
    accessorKey: "commitment_number",
    enableColumnFilter: true,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: "سال زراعی",
    accessorKey: "crop_year_name",
    enableColumnFilter: false,
  },
  {
    header: () => (
      <span className="flex">
        نام کشاورز
        {/* <ArrowDownUp size={15} className="text-blue-500 gap-2" /> */}
      </span>
    ),
    accessorKey: "farmer_name",
    enableColumnFilter: false,
  },
  {
    header: "نام روستا",
    accessorKey: "village_name",
    enableColumnFilter: true,
  },
  {
    header: "     مقدار زمین(هکتار)",
    accessorKey: "amount_of_land",
    enableColumnFilter: true,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },

  {
    header: "میزان برداشت (تن)",
    accessorKey: "withdrawal_amount",
    enableColumnFilter: true,
    cell: (cell: any) => (
      <Link
        to="#"
        className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
      >
        {cell.getValue()}
      </Link>
    ),
  },

  {
    header: "تاریخ قرارداد",
    accessorKey: "date_set",
    enableColumnFilter: false,
    cell: (cell: any) => (
      <Link
        to="#"
        className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
      >
        {cell.getValue()}
      </Link>
    ),
  },
  {
    header: "تاریخ  ایجاد",
    accessorKey: "created_at",
    enableColumnFilter: false,
    cell: (cell: any) => (
      <Link
        to="#"
        className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
      >
        {cell.getValue()}
      </Link>
    ),
  },
];

export default columnData;
